module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sky-swiper', {
      single: _vm.singleSlide
    }]
  }, [_c('div', {
    staticClass: "sky-swiper-frame"
  }, [_c('ul', {
    staticClass: "sky-swiper-slides"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.moreLink || _vm.moreEventsLink) ? _c('div', {
    staticClass: "swiper-more-container"
  }, [_c('ro-read-more', {
    staticClass: "swiper-more",
    attrs: {
      "inline": true,
      "href": _vm.moreEventsLink
    }
  }, [_vm._v("Se alle arrangementer")]), _vm._v(" "), _c('ro-read-more', {
    staticClass: "swiper-more",
    attrs: {
      "inline": true,
      "href": _vm.moreLink
    }
  }, [_vm._v("Se alle nyheder")])], 1) : _vm._e()]), _vm._v(" "), (!_vm.singleSlide) ? _c('div', {
    staticClass: "sky-swiper-buttons"
  }, [_c('button', {
    staticClass: "sky-swiper-prev"
  }, [_c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "sky-swiper-next"
  }, [_c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.options.showBullets && !_vm.singleSlide) ? _c('ul', {
    staticClass: "sky-swiper-bullets"
  }, _vm._l((_vm.slides), function(bullet, index) {
    return _c('li', [_c('button', {
      class: {
        active: index === _vm.currentSlide
      },
      on: {
        "click": function($event) {
          _vm.changeSlide(index)
        }
      }
    }, [_vm._v("\n        Slide #" + _vm._s(index) + "\n      ")])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-69a95548"}!./scripts/sky-swiper/sky-swiper.html
// module id = 374
// module chunks = 1